import {
  Component,
  HostListener,
  Input,
  OnInit,ViewChild
} from '@angular/core';

import { ModalController, Platform } from '@ionic/angular';

import { CartService } from '../../services/cart.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-popup-attribute',
  templateUrl: './popup-attribute.page.html',
  styleUrls: ['./popup-attribute.page.scss'],
})
export class PopupAttributePage implements OnInit {
  // @Input() data;
  // @Input() attributes;
  // drop_down2 = false;
  // // cart_items = [];
  // main_image;
  // @ViewChild('dropdown2', { read :ElementRef}) dropdown2 : ElementRef;
  custom;
  @Input() product_info:any;
  showmore:any = {};
  main_image;
  instructions:any;
  tray_number:any;
  weight:any;
  @Input() index;
  @Input() is_modal;
  @Input() item;
  is_weight_price = false;
  is_disble = false;
  custom_price;
  @Input() qty;
  @ViewChild('weight_focus') weight_focus : any;
  @Input() editorder;
  constructor(private platform: Platform,public ngcart:CartService,private modalCtrl:ModalController,public db:DataService) { }

  ngOnInit() {
    this.focusButton();
    this.ngcart.getvalue()
    // console.log('qty',this.product_info);
    if(this.product_info){
      this.product_info.weight_price = 0;
      if(this.product_info.net_price == undefined){
        this.product_info.net_price = this.product_info.price / this.product_info.weight;
        // this.custom_price = 
      }

      this.get_cart_item();
      
      this.check_image();
      if(this.is_modal){;
        this.instructions = this.product_info.note;
        this.custom_price = Number(this.product_info.minprice);
        this.tray_number =  this.item.item.tray_number;
        if(this.item.item.weight != undefined || this.item.item.weight != ''){
          this.weight = this.item.item.weight;
          this.is_disble = true;
        }

      }
      // this.db.mycart_emit.subscribe(res => {
      //   // console.log(res);
      //   if(res == 'getted'){
      //     this.get_recommeded();
      //   }
      // })
      // console.log(this.product_info)
    }
  }

  focusButton(){
    setTimeout(() => {
      if(this.platform.width() >= 1024)
        this.weight_focus.setFocus();
    }, 1000);
  }

  check_custom(){
      this.is_disble = true;
      this.weight = undefined;
       this.focusButton();
  }

  custom_calculate_balance(){
    // if(this.is_weight_price)
     // this.product_info.net_price = this.custom_price / this.product_info.weight;

  }

  calculate_balance(){
    
    if(this.weight != undefined && this.weight != ''){
      this.is_weight_price = true;
      this.product_info.weight_price = Number(this.product_info.net_price) * Number(this.weight);
      // console.log(this.product_info.weight_price);
    }
    else
      this.is_weight_price = false;
  }

  check_attribute_labels(data){
      let temp_label ='Select'
      if(data && data.length != 0){
        data.map(res =>{
          if(res.is_pre_selected == 1){
              temp_label = res.option_value
          } 
      })
      }
      return temp_label;
    }
    
check_image(){
     if(this.product_info.images){
      this.product_info.images.find(res=>{
        if(res.is_primary == 1){        
          if(res.product_image){
            this.main_image = res.product_image
          }else{
            this.main_image = res.image
          }
        }
      })
     }else{
       this.main_image = this.product_info.product_image
     }
    }

    check_attribute_cart(){  
      let ids = '';
      let selected_attribute ='';
      let selected_cart_id =''
      let selected_cart_count = ''
      this.product_info['product_attributes'].find(res => {
        res.options.find(data =>{  
          data.iscart = this.check_attribute(data.name+'\n');
           if(data.is_pre_selected == 1){   
             ids+=data.name+'\n';
             selected_cart_id = this.check_cart_id(ids);
             selected_cart_count = data.iscart
             selected_attribute += ' <div class="attribute"><span class="attr-title">'+res.attribute+'</span> : <span>'+data.option_value+'</span> </div>'
           } 
         })
         this.product_info.selected_cart_id = selected_cart_id
         this.product_info.ids = ids;
         this.product_info.count = selected_cart_count;
         if(this.product_info.product_attributes.length > 1){
          this.product_info.count =  this.check_attribute(this.product_info.ids);
        }  
         this.product_info.selected_attribute = '<div class="cart-attributes">'+selected_attribute+'</div>'
         this.check_attr_stock();
      })
    }
  

  select(type,id){
    this.focusButton();

      // this.is_disble = false;
      // this.is_weight_price = false;
      this.weight = undefined;
        this.product_info['product_attributes'].find(res => {
          if(res.attribute == type){
            res.options.find(d =>{ 
              if(d.name == id){
                d.is_pre_selected = 1;
                if(d.images && d.images.length != 0){
                  this.product_info.images = d.images;
                  this.check_image()
                }
              }else{
                d.is_pre_selected = 0
              }
            })
          }
        })
        this.check_attribute_cart();
        this.check_attr_stock();
       
    }

    check_attr_stock(){
       var data = {
          "product": this.product_info.name,
          "attribute_id": this.product_info.ids,
          "cart_qty": this.product_info.count,
          "variant_html" :'',
          customer:this.db.Customer && this.db.Customer.name ? this.db.Customer.name : ''
        }
      this.db.validate_attributes_stock(data).subscribe(res => {
        if(res.message != undefined){
        if(res.message.status == "Success"){
          this.product_info.price = res.message.price,
          this.product_info.old_price = res.message.old_price
          this.product_info.discount_percentage = res.message.discount.discount_label
          this.product_info.discount_rule = res.message.discount.discount_rule
          this.product_info.stock = res.message.stock
          this.product_info.stock_alert_message = undefined
          if(res.message.weight != undefined)
            this.product_info.net_price = res.message.price / res.message.weight;
          else
            this.product_info.net_price = res.message.price / 1000;
        }else if(res.message.status == 'Failed'){
          this.product_info.price = res.message.price,
          this.product_info.old_price = res.message.old_price
          this.product_info.stock_alert_message = res.message.message
        }
      }
      })
    }
  
 
//TAble attribute
get_selected_table_attribute(){
  this.product_info.product_attributes[0].options.map(value =>{
      if(!value.ids){

        let ids = ''
        let separate_ids = ''
        let selected_attribute = ''
        let separate_selected_Attribute = ''
  
          separate_ids += value.name+'\n';
          separate_selected_Attribute += ' <div class="attribute"><span class="attr-title">'+this.product_info.product_attributes[0].attribute+'</span> : <span>'+value.option_value+'</span> </div>'

          this.product_info.other_attributes.map(res =>{
            res.options.map(option=>{
              option.is_select_parent = value
              if(option.is_pre_selected == 1){
                ids += option.name+'\n';
                selected_attribute += ' <div class="attribute"><span class="attr-title">'+res.attribute+'</span> : <span>'+option.option_value+'</span> </div>'
              }
            })
          })
  
          ids = separate_ids + ids
          selected_attribute = separate_selected_Attribute + selected_attribute
  
         
          value.ids = ids;
          value.selected_attribute = '<div class="cart-attributes">'+selected_attribute+'</div>'
          value.count =  this.check_attribute(ids);
          // console.log("selecetd count  "+value.count  )
          value.selected_cart_id = this.check_cart_id(ids);

          var data = {
            "product": this.product_info.name,
            "attribute_id":  value.ids,
            "cart_qty": value.count,
            "variant_html" : value.selected_attribute,
            customer:this.db.Customer.name ? this.db.Customer.name : ''
          }
      
            this.db.validate_attributes_stock(data).subscribe(data => {
              if(data.message.status == "Success"){
                value.price = data.message.price,
                value.old_price = data.message.old_price
                value.discount_label = data.message.discount.discount_label
                value.discount_rule = data.message.discount.discount_rule
                value.stock_alert_message = undefined
              }else if(data.message.status == 'Failed'){
                value.price = data.message.price,
                value.old_price = data.message.old_price
                value.stock_alert_message = data.message.message
              }
            })
  
      } else {
            value.count =  this.check_attribute(value.ids);
            value.selected_cart_id = this.check_cart_id(value.ids);
      }

      // console.log("just check")
      // console.log(ids)
   
  })
  
}  
   
//addtocart
async addtocart(value) {  
    if(this.db.isNgCart == true){
      var addons:any = []
     if(this.product_info.product_attributes && this.product_info.product_attributes.length > 0){
      for (var i = 0; i < this.product_info.product_attributes.length; i++) {
        var k = i;
        for (var j = 0; j < this.product_info.product_attributes[k].options.length; j++) {
          if (this.product_info.product_attributes[k].options[j].is_pre_selected == 1) {
            if(this.product_info.product_attributes[k].attribute == 'Weight' && this.product_info.weight_price != 0){
              this.product_info.product_attributes[k].options[j].addon_name = this.product_info.product_attributes[k].attribute
              this.product_info.is_custom_weight = 1
              this.product_info.product_attributes[k].options[j].is_custom_weight = 1
              this.product_info.product_attributes[k].is_custom_weight = 1
              this.product_info.product_attributes[k].options[j].weight = this.weight
              // this.product_info.product_attributes[k].options[j].weight = this.weight
              this.product_info.weight = this.weight
              // this.product_info.product_attributes[k].options[j].weight_value = this.product_info.weight
              this.product_info.product_attributes[k].options[j].product_attribute=this.product_info.product_attributes[k].attribute
              addons.push(this.product_info.product_attributes[k].options[j])
            }else{
            this.product_info.product_attributes[k].options[j].addon_name = this.product_info.product_attributes[k].attribute
            this.product_info.product_attributes[k].options[j].product_attribute=this.product_info.product_attributes[k].attribute
            addons.push(this.product_info.product_attributes[k].options[j])
          }
          }
        }
      }
    }
    value.quantity = value.cart_count
    value.id = value.name;
    value.title = value.item;
 
    if (value.discount_price) {
      value.minprice = value.discount_price;
      value.prices = value.discount_price;
    }
    else if(this.product_info.is_custom_weight){
      value.minprice = this.product_info.weight_price;
      value.prices = this.product_info.weight_price;
      
    }
    else {
      value.minprice = value.price;
      value.prices = value.price;
    }

    if(this.custom_price){
     value.minprice = this.custom_price;
      value.prices = this.custom_price; 
    }
    value.note =  this.instructions;
    value.tray_number =  this.tray_number;
    // value.addon_vaule = addons;

    // this.db.ngcart.getAllCartItems();
    if(this.editorder){
      this.modalCtrl.dismiss({value:value, addons:addons})
    }
    else{
      if(this.is_modal){
          // this.ngcart.remove_cart_item(value.name, this.index);
          if(this.item.quantity == 1)
            this.ngcart.removecartItemById(value.name,this.index,'','')
          else
            this.ngcart.remove_cart_item(value.name, this.index);
          // this.ngcart.removeoneItemById(value.name,this.index,'','')
          // if(this.item.quantity == 1)
            this.ngcart.addItem(value,this.qty, value, addons,'','', '')
          // else
            // this.ngcart.addcartItem(value, this.item.quantity - 1, value,this.index,'','')
        }
       else
        this.ngcart.addItem(value, 1, value, addons,'','', '')
      this.db.cart_items = this.ngcart.TableCartItems('')
      this.db.cart_count = this.ngcart.getTableCartLength('')
      this.db.sub_total = this.ngcart.getTableCartTotal('')
      this.db.sub.next('cart emitted');
      this.db.sub.next('cart emit');
      this.weight = undefined;
      this.get_cart_item()
      this.get_recommeded()
      this.modalCtrl.dismiss('success')
    }
    // this.cartitem = this.ngcart.TableCartItems(this.tableID)
  }
  else{
        var datas={
           item_code:value.name,
           qty: value.cart_count,
           qty_type: "",
           rate:value.price,
           cartType:"Shopping Cart",
           customer:localStorage['customerRefId'],
           attribute: value.selected_attribute,
           attribute_id: value.ids
        }
        this.db.insert_cart_items(datas).subscribe(data => { 
           if(data.message.status == "failed"){
               this.db.alert(data.message.message)
           } else {
              if(localStorage['customerRefId'] == undefined){
                localStorage['customerRefId'] = data.message.customer
                localStorage['guestRefId'] = data.message.customer
              }
              this.get_cart_item()
              // this.modalCtrl.dismiss();
           }
       }, error => { console.log(JSON.stringify(error.json())); }); 
  // }else{
  //   console.log(value.product_attributes);

  }
 }

 select_attribute(parent_attribute,child_attribute,attr_option){ 
  this.product_info.other_attributes.map(res =>{
      // if(res.control_type == child_attribute.control_type){
      if(res.name == child_attribute.name){
          res.options.map(option=>{
               option.is_select_parent = parent_attribute;
              if(option.name == attr_option){
                  option.is_pre_selected = 1; 
              } else {
                  option.is_pre_selected = 0;
              }
          })
      }
  })
  // console.log()
  this.get_selected_attributes(parent_attribute.name);
}




get_selected_attributes(parent_id){
   this.product_info.product_attributes[0].options.map(res => {
      if(res.name == parent_id){

        let ids = ''
        let separate_ids = ''
        let selected_attribute = ''
        let separate_selected_Attribute = ''

        this.product_info.other_attributes.map(res =>{
          res.options.map((option,index)=>{
              if(option.is_pre_selected == 1 && option.is_select_parent && option.is_select_parent != ''){
                  // console.log(option.is_select_parent.name)
                  separate_ids = option.is_select_parent.name+'\n'
                  separate_selected_Attribute = ' <div class="attribute"><span class="attr-title">'+option.is_select_parent.attribute+'</span> : <span>'+option.is_select_parent.option_value+'</span> </div>'
                  ids += option.name+'\n';
                  selected_attribute += ' <div class="attribute"><span class="attr-title">'+res.attribute+'</span> : <span>'+option.option_value+'</span> </div>'
              }
          })
        })
    
         ids = separate_ids + ids
         selected_attribute = separate_selected_Attribute + selected_attribute

         
          res.selected_cart_id = this.check_cart_id(ids);
          res.ids = ids;
          res.selected_attribute = '<div class="cart-attributes">'+selected_attribute+'</div>'
          res.count = this.check_attribute(res.ids);

        var data = {
          "product": this.product_info.name,
          "attribute_id":  res.ids,
          "cart_qty": this.product_info.count,
          "variant_html" : res.selected_attribute,
          customer:this.db.Customer.name ? this.db.Customer.name : ''
        }
    
        this.db.validate_attributes_stock(data).subscribe(data => {
          // console.log(data)
          if(data.message.status == "Success"){
            res.price = data.message.price,
            res.old_price = data.message.old_price
            res.discount_label = data.message.discount.discount_label
            res.discount_rule = data.message.discount.discount_rule
            res.stock_alert_message = undefined
          }else if(data.message.status == 'Failed'){
            res.price = data.message.price,
            res.old_price = data.message.old_price
            res.stock_alert_message = data.message.message
          }
        })

       

      }
    })



  // console.log(ids);
  // console.log(selected_attribute);
  // this.product_info.ids = ids;
  // this.product_info.selected_attribute = '<div class="cart-attributes">'+selected_attribute+'</div>'
}


check_active(item,option){
  // console.log("check active,",item,option)
  if(item.ids){
    let v = item.ids.split('\n');
      return  v.includes(option.name)
  } else {
    if(option.is_pre_selected == 1){
      return option.is_pre_selected == 1
    }
  }
 
}

  // Check attribute lable
  check_attribute_label(data,item){
    let temp_label ='Select'
    if(data && data.length != 0){
      data.map(res =>{
        if(item.ids){
          let v = item.ids.split('\n');
            if(v.includes(res.name))  {
              temp_label = res.option_value
            }
        } else {
          temp_label = res.option_value
        } 
      })
    }
    return temp_label;
  }



table_addtocart(data){
  this.product_info.count = data.count
  this.product_info.price = data.price
  this.product_info.ids = data.ids;
  // console.log("add",this.product_info.count)
  this.product_info.selected_cart_id = data.selected_cart_id;
  this.product_info.selected_attribute = data.selected_attribute
      if(data.count != 0){
        this.update_cart(this.product_info);
      } else if(data.count == 0) {
        this.addtocart(this.product_info);
      }

  }


table_removetocart(data){
  // console.log("remove",this.product_info.count)
    this.product_info.selected_cart_id = data.selected_cart_id;
    this.product_info.count = data.count
    // console.log(data)
    this.removetocart(this.product_info);
}



//   add_cart(data, count) {
//     data.cart_count = count;
//     this.addtocart(data)
//   }

//   remove_cart(data, count) {
//     data.cart_count = count;
//     this.removetocart(data)
//   }
  
//    //Remove Cart
//    async removetocart(value) {

//     if(value.product_attributes.length == 0){
//       this.db.cart_items.find(res => {  
//             if (res.product == value.name) {  
//               value.selected_cart_id = res.name
//             }
//         })
//       }

//     if(value.cart_count == 0){
//         var datass={
//           name: value.selected_cart_id,
//           customer: localStorage.customerRefId,
//           user:""
//         }
//         this.db.delete_cart_items(datass).subscribe(data => {
//           this.get_cart_item()
//       }, error => { console.log(JSON.stringify(error.json()));});
//     }else{
//         var datas={
//           name: value.selected_cart_id,
//           qty:value.cart_count,
//           qty_type:""
//         }
//       this.db.update_cart_items(datas).subscribe(data => {
//             this.get_cart_item()
//       }, error => {console.log(JSON.stringify(error.json())); });
//   }
// }

async update_cart(list) {
  var datas = {  name: list.selected_cart_id, qty: this.db.plusCount(list.count),  qty_type:"" }
  this.db.update_cart_items(datas).subscribe(data => {
     if(data.message.status == 'error'){
       var d = JSON.parse(data._server_messages);
       var d1 = JSON.parse(d);
       this.db.alert(d1.message)
     } else { 
       this.get_cart_item();
     }
  }, error => { console.log(JSON.stringify(error.json())); });
}

async removetocart(value) {

    if(value.product_attributes.length == 0){
      this.db.cart_items.find((res:any) => {  
            if (res.product == value.name) {  
              value.selected_cart_id = res.name
            }
        })
      }

    if(this.db.removeCount(value.count) == 0){
        var datass={
          name: value.selected_cart_id,
          customer: localStorage['customerRefId'],
          user:""
        }
        this.db.delete_cart_items(datass).subscribe(data => {
          this.get_cart_item()
      }, error => { console.log(JSON.stringify(error.json()));});
    }else{
        var datas={
          name: value.selected_cart_id,
          qty: this.db.removeCount(value.count),
          qty_type:""
        }
      this.db.update_cart_items(datas).subscribe(data => {
            this.get_cart_item()
      }, error => {console.log(JSON.stringify(error.json())); });
  }
}

//get Cart Item
get_cart_item(){
  if(this.db.isNgCart == true)
  {
    this.db.cart_items = this.ngcart.TableCartItems('')
    this.db.cart_count = this.ngcart.getTableCartLength('')
    this.db.sub_total = this.ngcart.getTableCartTotal('')
    this.db.sub.next('cart emitted');
    this.get_recommeded();
  }
  else{
  if(localStorage['customerRefId'] != undefined){
      var ddatas={
        customer:localStorage['customerRefId'],
        user:""
      }
    this.db.get_cart_items(ddatas).subscribe(data => {
      // if(data.message.cart && data.message.cart != null && data.message.cart.items.length != 0){
      //   this.db.cart_items = data.message.cart.items;
      //   this.db.cart_count = data.message.cart.items.length;
      // }else{
      //   this.db.cart_items = []
      // }
      // this.db.store_cart_datas(data);
      this.get_recommeded();
    }, error => { console.log(JSON.stringify(error.json())); });
  } else {
    this.get_recommeded();
    this.product_info.count  = 0;
  }  
  }  
}


  get_recommeded() {
    this.product_info.count = this.checkcart(this.product_info.name);
  // this.product_info.wish_count = this.checkWishCart(this.product_id);

  if(this.product_info.product_attributes.length != 0){

    if(this.product_info.show_price != 0){
      this.check_attribute_cart();
    } else if(this.product_info.show_price == 0){
      this.get_selected_table_attribute()
    }
   
  }
  }

  checkcart(id) {
    var cnt = 0;
    if(this.db.isNgCart == true)
      this.db.cart_items.find((res:any) => {  if (res.id == id && res.is_free_item != 1) {  cnt += res.quantity } })
    else
      this.db.cart_items.find((res:any) => {  if (res.product == id && res.is_free_item != 1) {  cnt += res.quantity } })
    return cnt;
    // this.db.cart_items.find(res => {  if (res.product == id) {  cnt += res.quantity } })
    // return cnt;
  }

  check_attribute(id){
    var cnt = 0;
    this.db.cart_items.find( (res:any) =>{
      if(res.attribute_ids && res.attribute_ids == id){
        cnt += res.quantity
      }
    })
    return cnt;
  }


  check_cart_id(id){
    let cart_id =''
    this.db.cart_items.find( (res:any) =>{
      if(res.attribute_ids == id){
        if(res.quantity != 0){
          cart_id = res.name
        }
      }
    })
    return cart_id;
  }

  check_active_radio(options,item){
        if(item.attribute == 'Weight'){
          return 'custom';
        }else{
        let temp = ''
          options.map(res =>{
              if(res.is_pre_selected == 1){
               
                  temp = res.name
              }
          })
          return temp;
        }
      }

      select_dropdown(event,type){
      this.select(type,event.detail.value) 
  }


  close(){
      this.modalCtrl.dismiss()
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event) {
    let key = event.key;
    if (key == 'ArrowDown') {
        
    } else if (key == 'ArrowUp') {
        
    }
    else if (key == 'ArrowRight') {
        
    }
    else if (key == 'ArrowLeft') {
       
    }
    else
      this.shortcuts(event);
  }

  shortcuts(event){

  }



  // checkcart(id) {
  //   var cnt = 0;
  //   this.db.cart_items.find(res => {  if (res.product == id) {  cnt += res.quantity } })
  //   return cnt;
  // }

  // check_attribute(id){
  //   var cnt = 0;
  //   this.db.cart_items.find( res =>{
  //     if(res.attribute_ids && res.attribute_ids == id){
  //       cnt += res.quantity
  //     }
  //   })
  //   return cnt;
  // }

  // check_cart_id(id){
  //   let cart_id =''
  //   this.db.cart_items.find( res =>{
  //     if(res.attribute_ids == id){
  //       if(res.quantity != 0){
  //         cart_id = res.name
  //       }
  //     }
  //   })
  //   return cart_id;
  // }

  // close(){
  //     this.modalCtrl.dismiss()
  // }

  // calculate_balance(){
  //   if(this.weight != undefined && this.weight != ''){
  //     this.is_weight_price = true;
  //     this.product_info.weight_price = Number(this.product_info.net_price) * Number(this.weight);
  //     // console.log(this.product_info.weight_price);
  //   }
  //   else
  //     this.is_weight_price = false;
  // }


  custom_radio_b(){
   
  }

}
